import React from "react";
import styled from "styled-components";
import webdevelopment from '../Assets/Azharpic3.jpg';

// Main wrapper for the page
const Wrap = styled.div`
width: 100%;
height: auto;
padding:0px;
margin:0px;
box-sizing: border-box;
background-color: #f9f9f9; /* Light background for better readability */
  }
`;

// Container for content
const PageWrapper = styled.div`
  max-width: 900px;
  width: 90%;
  margin: 20px auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 16px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    font-size: 15px;
    padding: 18px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 15px;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;

// Page Title
const Title = styled.h1`
  text-align: center;
  margin-bottom: 25px;
  font-size: 2rem;
  background: linear-gradient(90deg, #ff7e5f, #feb47b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

// Responsive Image
const MobileAppImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  // border-radius: 10px;
  margin-bottom: 25px;

  @media (max-width: 1024px) {
    max-height: 320px;
  }

  @media (max-width: 768px) {
    max-height: 250px;
  }

  @media (max-width: 480px) {
    max-height: 200px;
    margin-bottom: 20px;
  }
`;

// Paragraph styling
const Paragraph = styled.p`
  margin-bottom: 15px;
  line-height: 1.8;

  b {
    font-weight: 600;
  }

  @media (max-width: 480px) {
    margin-bottom: 12px;
  }
`;

export default function PrivacyPolicy() {
  return (
    <Wrap>
      <MobileAppImage src={webdevelopment} alt="Background" />
      <PageWrapper>
        <Title>Privacy Policy</Title>
        <Paragraph>
          At <b>BuyNesta</b>, we respect your privacy and are committed to
          protecting the personal information you share with us. This policy
          explains how we collect, use, and safeguard your data.
        </Paragraph>
        <Paragraph>
          <b>Information We Collect:</b> We may collect non-personal data such as
          browser type, device, and usage details to improve your experience.
        </Paragraph>
        <Paragraph>
          <b>Cookies:</b> We use cookies and affiliate tracking codes to ensure
          proper functioning of the Amazon Associates Program.
        </Paragraph>
        <Paragraph>
          <b>Third-Party Links:</b> Our website contains links to Amazon. When
          you click and purchase, Amazon’s privacy policies apply.
        </Paragraph>
        <Paragraph>
          <b>Consent:</b> By using our site, you consent to this Privacy Policy.
        </Paragraph>
      </PageWrapper>
    </Wrap>
  );
}
